import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import { gql } from '@apollo/client';
import DatePicker from 'react-datepicker';

import InputHeader from '../global/inputwithHeader';

import _, { forEach } from 'lodash';

import { withRouter } from '../../../services/withRoute';

import Modal from '../../components/modals';
import Select from 'react-select';
const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			employees {
				_id
				name
				dp_signed_url
				designation
			}
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			model
			description
			manufacturer
			manufacturerId
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdBy
			createdAt
			updatedBy
			updatedAt
			branch {
				_id
				branchId
			}
		}
	}
`;
const assignEqtoEmployee = gql`
	mutation AssignEqToEmpAsAsset($qrCodes: [String!], $employee: EmployeeObjectInput) {
		assignEqToEmpAsAsset(qrCodes: $qrCodes, employee: $employee) {
			message
		}
	}
`;
const assignMctoEmployee = gql`
	mutation AssignMcToEmpAsAsset($qrCodes: [String!], $employee: EmployeeObjectInput) {
		assignMcToEmpAsAsset(qrCodes: $qrCodes, employee: $employee) {
			message
		}
	}
`;
const receiveMcfromEmployee = gql`
	mutation ReceiveMcFromEmpAsAsset($employeeId: ID!, $qrCodes: [String!]) {
		receiveMcFromEmpAsAsset(employeeId: $employeeId, qrCodes: $qrCodes) {
			message
		}
	}
`;
const receiveEqfromEmployee = gql`
	mutation ReceiveEqFromEmpAsAsset($employeeId: ID!, $qrCodes: [String!]) {
		receiveEqFromEmpAsAsset(employeeId: $employeeId, qrCodes: $qrCodes) {
			message
		}
	}
`;
const getMemoryCard = gql`
	query MemoryCard($mcIdentifier: String) {
		memoryCard(mcIdentifier: $mcIdentifier) {
			employees {
				_id
				name
				dp_signed_url
				designation
			}
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			manufacturerId
			manufacturer
			description
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdAt
			updatedBy
			updatedAt
			size
			isReceived
			subStatus
			branch {
				_id
				branchId
			}
		}
	}
`;
class AssignReceiveAsset extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			assignedTo: null,
			qrCode: '',
			qrCodeError: false,
			qrCodeDuplicate: false,
			equipments: [],
			qrCodeList: [],
		};
	}
	handleCloseModal = () => {
		this.props.handleClose();
	};

	isDisabled = () => {
		if (this.state.qrCodeErrorMessage?.length > 0) return true;
		if (this.props.actionType === 'assign') {
			if (this.state.assignedTo !== null && _.size(this.state.equipments) > 0) {
				return false;
			} else {
				return true;
			}
		} else {
			if (_.size(this.state.equipments) > 0) {
				return false;
			} else {
				return true;
			}
		}
	};
	handleEventChange = (e, name) => {
		this.setState(
			{
				qrCode: e.target.value,
				qrCodeError: false,
				qrCodeErrorMessage: '',
			},
			async () => {
				if (
					_.size(
						_.filter(this.state.equipments, {
							qrCode: e.target.value.toUpperCase(),
						}),
					) > 0
				) {
					let statusKey = _.filter(this.state.equipments, {
						qrCode: e.target.value.toUpperCase(),
					})[0].status;
					let employeeArray = _.filter(this.state.equipments, {
						qrCode: e.target.value.toUpperCase(),
					})[0].employees;
					this.setState({
						qrCodeError: true,
						qrCodeErrorMessage:
							(_.size(
								this.state.equipments.filter((eqp) => {
									return (
										eqp.qrCode == e.target.value.toUpperCase() &&
										eqp.status != 'ready'
									);
								}),
							) > 0 &&
								this.props.actionType === 'assign') ||
							(_.size(
								this.state.equipments.filter((eqp) => {
									return (
										eqp.qrCode == e.target.value.toUpperCase() &&
										eqp.status != 'busy'
									);
								}),
							) > 0 &&
								this.props.actionType !== 'assign')
								? `Equipment is ${statusKey}`
								: this.props.actionType !== 'assign' &&
								  (!employeeArray || employeeArray?.length == 0)
								? 'No employees are assigned'
								: _.size(
										_.filter(this.state.equipments, {
											qrCode: e.target.value.toUpperCase(),
										}),
								  ) > 0
								? 'Memory Card already Scanned'
								: '',
					});
				} else if (
					e.target.value !== '' &&
					e.target.value.length >= 4 &&
					_.size(
						_.filter(this.state.equipments, {
							qrCode: e.target.value.toUpperCase(),
						}),
					) == 0
				) {
					if (this.props.assetType === 'memoryCard') {
						let json = { mcIdentifier: e.target.value.toUpperCase() };
						await this.getMemoryCardInfo(getMemoryCard, json, true);
					} else {
						let json = { eqIdentifier: e.target.value };

						await this.getEquipmentInfo(getEquipment, json);
					}
				}
			},
		);
	};
	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedTo: e,
		});
	};
	handleAssignReceive = async (e) => {
		let json;
		let isEmptyList = [];
		let receiveMCVariables;
		isEmptyList = this.state.equipments;
		if (_.size(isEmptyList) > 0) {
			let qrCodes = [];
			_.forEach(isEmptyList, (equipment, key) => {
				qrCodes.push(equipment.qrCode);
			});
			if (this.props.actionType === 'assign') {
				receiveMCVariables = {
					qrCodes,
					employee: {
						_id: this.state.assignedTo.value,
						name: this.state.assignedTo.label,
					},

					// employeeId: this.state.assignedTo.value,
				};
			} else {
				receiveMCVariables = {
					qrCodes,
					employeeId: this.state.assignedTo.value,
				};
				// employeeId: this.state.assignedTo.value,
			}

			if (this.props.actionType === 'assign') {
				if (this.props.assetType === 'memoryCard') {
					await this.assignReceiveAsset(
						assignMctoEmployee,
						receiveMCVariables,
						this.props.type,
					)
						.then(() => {
							this.handleCloseModal();
						})
						.then(() => {
							window.location.reload();
						});
				} else {
					await this.assignReceiveAsset(
						assignEqtoEmployee,
						receiveMCVariables,
						this.props.type,
					)
						.then(() => {
							this.handleCloseModal();
						})
						.then(() => {
							window.location.reload();
						});
				}
			} else {
				if (this.props.assetType === 'memoryCard') {
					await this.assignReceiveAsset(
						receiveMcfromEmployee,
						receiveMCVariables,
						this.props.type,
					)
						.then(() => {
							this.handleCloseModal();
						})
						.then(() => {
							window.location.reload();
						});
				} else {
					await this.assignReceiveAsset(
						receiveEqfromEmployee,
						receiveMCVariables,
						this.props.type,
					)
						.then(() => {
							this.handleCloseModal();
						})
						.then(() => {
							window.location.reload();
						});
				}
			}
		}
	};
	render() {
		console.log('logging props', this.state.assignedTo);
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
				custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="project-add-edit-popup edit-shoot-details">
					<div
						className="project-add-edit-popup-header"
						style={{
							alignItems: this.props.activeShootID == null ? 'center' : 'flex-start',
							flexDirection: this.props.activeShootID == null ? 'row' : 'column',
							height: this.props.activeShootID == null ? '56px' : '70px',
						}}
					>
						<span className="header-title" style={{ textTransform: 'capitalize' }}>
							{this.props.type}
						</span>
					</div>

					<div className="project-add-edit-popup-body">
						<div className="project-add-edit-popup-body-item" id={'details'}>
							<div className="floating-select-container"></div>
							<div className="floating-select-container">
								<label>
									{this.props.actionType === 'assign'
										? 'Assign To'
										: 'Receive From'}
								</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.props.assignedToOptions}
									onChange={(e) => this.handleEditCrewName(e)}
									defaultValue={this.state.assignedTo}
									isSearchable={true}
									// menuPortalTarget={document.body}
									menuPosition={'fixed'}

									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>
							<InputHeader
								type="text"
								name="qrCode"
								value={this.state.qrCode}
								onChange={(e) => this.handleEventChange(e, 'qrCode')}
								isInputError={this.state.qrCodeError}
								errorMessage={this.state.qrCodeErrorMessage}
								label="QR Code"
							/>

							<div className="arcbl-list">
								<div className="assign-hdd-item ">
									<div className="column column-20w">
										<span>Qr Code</span>
										<span>description</span>
										<span>type</span>
										<span>empty card</span>

										<span></span>

										{/* <span>damage</span> */}
									</div>

									{_.size(this.state.equipments) > 0 ? (
										_.map(
											this.props.actionType == 'assign'
												? this.state.equipments.filter(
														(eqp) => eqp.status === 'ready',
												  )
												: this.state.equipments.filter((eqp) => {
														return (
															eqp.status === 'busy' &&
															eqp?.employees?.length > 0
														);
												  }),

											(equipment, key) => {
												return (
													<div className="hitem column-20w listHitem">
														<span
															style={{
																display: 'flex',
																alignItems: 'center',
															}}
														>
															{equipment.qrCode}

															<b
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	marginLeft: 5,
																}}
																className={'orange-info'}
															>
																<Info />
															</b>
														</span>
														<span>{equipment.description}</span>
														<span>{equipment.type}</span>
														<span>
															<label class="checkbox-container">
																<input
																	type="checkbox"
																	checked={
																		_.has(equipment, 'isEmpty')
																			? equipment.isEmpty
																			: false
																	}
																/>
																<span
																	class="checkmark"
																	style={{ minWidth: '19px' }}
																></span>
															</label>
														</span>

														<span
															style={{
																cursor: 'pointer',
															}}
															onClick={(e) =>
																this.deleteItem(e, equipment.qrCode)
															}
														>
															{' '}
															<Delete />
														</span>
													</div>
												);
											},
										)
									) : (
										<div className="empty">
											<p>
												No {this.props.assetType} Added <br />
												Please scan or type in the {this.props.assetType} ID
											</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					<div className="bottom-popup-action-container">
						<span className="cancel-btn" onClick={() => this.handleCloseModal()}>
							Cancel
						</span>

						<span
							className={this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'}
							onClick={(e) => {
								// this.editAssetApiCall();
								if (!this.isDisabled()) {
									this.handleAssignReceive(e);
								}
							}}
						>
							<span>Save</span>
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}
export default withRouter(AssignReceiveAsset);
